export const formatNumber = (num: number, maxDigits?: number): string => {
  if (num === 0) return num.toString();
  if (maxDigits) return num.toFixed(maxDigits);
  // Compare magnitude, not the signed value — otherwise every negative number is < 0.0001 and gets
  // rendered in scientific notation (e.g. -0.000842 → "-8.42e-4", -5 → "-5.00e+0").
  const magnitude = Math.abs(num);
  if (magnitude < 0.0001 || magnitude > 999999999.99) {
    // Use scientific notation for magnitudes smaller than 0.0001 or larger than 999999999.99
    return num.toExponential(2);
  } else if (magnitude < 0.01 && magnitude >= 0.001) {
    return num.toFixed(3);
  } else if (magnitude < 0.001 && magnitude >= 0.00001) {
    return num.toFixed(4);
  } else {
    const numString = num.toFixed(2);

    // Remove trailing zeros and the decimal point if there are no decimals
    return numString.replace(/\.?0*$/, "");
  }
};
